import React, { createContext, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ForgotPin from './Pages/Credentials/forgotPin';
import VerifyOtp from './Pages/Credentials/verifyOtp';
import ResetPin from './Pages/Credentials/resetPin';
import Login from './Pages/Credentials/login';
import Layout from '../src/Pages/Layout/layout';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CreatePassword from './Pages/AcceptInvitaion/createPin';
export const Notifications = createContext({})


function App() {
  const [count, setCount] = useState({ totalCount: 0 })
  const adminData = JSON.parse(localStorage.getItem('adminData'))
  const [userInfo, setUserInfo] = useState(adminData)
  // const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  // const isDesktopViewport = window.innerWidth > 1024; // Adjust breakpoint if needed
  // console.log(isDesktopViewport,'isDesktopViewport')
  
  // const isDesktopModeOnMobile = isMobileDevice && isDesktopViewport;
  
  // console.log(isDesktopModeOnMobile ? "Desktop Mode on Mobile" : "Normal Mode");
  
  return (
    <>
      <Notifications.Provider value={{ count, setCount,userInfo, setUserInfo }}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='layout/*' element={<Layout />} />
            <Route path='forgotPin' element={<ForgotPin />} />
            <Route path='verifyOtp' element={<VerifyOtp />} />
            <Route path='verifyOtp/resetPin' element={<ResetPin />} />
            <Route path="/acceptInvitationMarketingTeam/:token" element={<CreatePassword />} />
          </Routes>
        </BrowserRouter>
      </Notifications.Provider>
    </>
  );
}

export default App;
